import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  grey1,
  grey5,
  grey7,
  grey8,
  grey10,
} from 'approot/shared/styles/colours.style';
import {
  font14,
  font16,
  OlStyled,
} from 'approot/shared/styles/typography.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';

export const AssignClassBox = styled(Box).attrs({
  $gap: 8,
  $marginBottom: 24,
  $flexDirection: 'column',
  $alignItems: 'flex-start',
})`
  position: relative;
  ${mediaUp.md`
    flex-direction: row;
    flex-wrap: nowrap;
  `}
`;

export const AssignClassDetail = styled.div`
  ${font16}

  width: 100%;

  ${OlStyled} {
    color: ${grey7};
    li {
      margin-bottom: ${rem(spacing16)};
    }
  }

  strong {
    color: ${grey10};
  }

  ${mediaUp.md`
    flex: 1;
    width: auto;
  `}
`;

export const AssignClassActions = styled(Box).attrs({
  $gap: 16,
  $alignItems: 'center',
  $justifyContent: 'space-between',
})`
  flex-direction: column;

  ${mediaUp.md`
    flex-direction: row;
  `}
`;

export const AssignClassOr = styled.div`
  ${font14}
  color: ${grey8};
  height: ${rem(40)};
  width: 100%;
  position: relative;

  ${mediaUp.md`
    height: 100%;
    width: ${rem(40)};
    position: static;
  `}

  span {
    background-color: ${grey1};
    display: block;
    padding: ${rem(spacing8)};
    position: absolute;
    left: 50%;
    margin-left: -${rem(17)};
    z-index: 1;

    ${mediaUp.md`
      top: 50%;
      margin-top: -${rem(20)};
    `}
  }

  &:after {
    content: '';
    background-color: ${grey5};
    position: absolute;
    width: 100%;
    height: ${rem(1)};
    left: 0;
    top: 50%;

    ${mediaUp.md`
      height: 100%;
      width: ${rem(1)};
      left: 50%;
      top: 0;
      bottom: 0;
    `}
  }
`;

export const AssignClassDetailBouncer = styled.div`
  padding: ${rem(spacing16)};
`;
